import { render } from "./app-logo-fpx.vue?vue&type=template&id=9a29ecca"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/image/app-logo-fpx.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9a29ecca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9a29ecca', __exports__)) {
    console.log('reload')
    api.reload('9a29ecca', __exports__)
  }
  
  module.hot.accept("./app-logo-fpx.vue?vue&type=template&id=9a29ecca", () => {
    console.log('re-render')
    api.rerender('9a29ecca', render)
  })

}


export default __exports__